<template>
  <div class="container">
    <div class="card bg-secondary shadow border-0">
      <div class="card-body px-lg-5 py-lg-5">
        <div class="text-center mt-2 mb-4">
          <h3>Welcome to the TCP Health Club</h3>
          <h5>To proceed, please login with Strava</h5>
          <strava-login></strava-login>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import StravaLogin from "@/components/StravaLogin";

export default {
  components: {
    // Banner,
    StravaLogin,
  },
  data() {
    return {
      login: {},
    };
  },
  created() {},
  methods: {},
};
</script>

<style scoped>
@import "../assets/styles/bootstrap-overrides.css";
.bg-secondary {
  background-color: #f5f6ff !important;
}

.container {
  width: 100%;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>